// extracted by mini-css-extract-plugin
export var blue = "_21-g";
export var brand = "_21-c";
export var darkGrey = "_21-f";
export var disabled = "_21-6";
export var disabledSubtle = "_21-7";
export var error = "_21-8";
export var green = "_21-h";
export var grey = "_21-e";
export var icon = "_21-0";
export var inherit = "_21-b";
export var lightGrey = "_21-d";
export var orange = "_21-j";
export var pink = "_21-l";
export var primary = "_21-1";
export var purple = "_21-m";
export var quaternary = "_21-4";
export var quinary = "_21-5";
export var red = "_21-k";
export var secondary = "_21-2";
export var success = "_21-a";
export var tertiary = "_21-3";
export var warning = "_21-9";
export var white = "_21-n";
export var yellow = "_21-i";